export default "__VITE_ASSET__jA4JVxMh__"